import tableRomanConversion from '../commons/tableRomanConversion/tableRomanConversion.vue'
import { equivalencesRomanInt, equivalencesIntRoman2 } from '../commons/tableRomanConversion/equivalencesIntRoman';
import equivalencesIntRoman from '../commons/tableRomanConversion/equivalencesIntRoman'
const convertRoman = require("roman-to-arabic-numerals");

export default {
	name: 'RomanToInt',
	props: {
		number: { type: String, required: true}
	},
	components: { tableRomanConversion },
	data() {
		return  {
			result: Number,
		}
	},
	created() {
	},
	mounted() {},
	methods: {},
	computed: {
		conversionWay() {
			return Number(this.number) == this.number ? 'itr' : 'rti';
		},
		isRTI() {
			return this.conversionWay == 'rti';
		},
		isITR() {
			return this.conversionWay == 'itr';
		},
		equivalences() {
			let decompose = [], number = this.number.toString(), n = number.length, explain = null, result;
			if (this.isRTI) {
				result = 0;
				for (let i = 0; i < n; i++) {
					let roman = number.charAt(i), numeral = equivalencesRomanInt[roman];
					if (i == n - 1) {
						decompose.push({roman: roman, numeral: numeral});
					} else {
						let num = numeral, next_roman = number.charAt(i + 1), next_numeral = equivalencesRomanInt[next_roman];
						if (next_numeral > numeral) {
							roman = `${roman}${next_roman}`;
							numeral = next_numeral - numeral;
							explain = `${roman} = ${next_numeral} - ${num}`;
							decompose.push({roman: roman, numeral: numeral, explain: explain});
							i++;
						} else {
							let j = 1, num = numeral;
							while (number.charAt(i + 1) == roman) {
								j++;
								i++;
							}
							roman = Math.pow(10, j).toString().replace(/1/g, '').replace(/0/g, roman);
							numeral = j * numeral;
							// explain = j == 1 ? null : `${roman} = ${j} x ${num}`;
							decompose.push({roman: roman, numeral: numeral, explain: explain});
						}
					}
					result += numeral;
				}
				return {decompose: decompose, result: result};
			} else {
				log('equivalencesIntRoman:', equivalencesIntRoman);
				let equivalences = equivalencesIntRoman.sort((a, b) => b.numeral - a.numeral), i = 0;
				n = equivalences.length;
				result = '';
				if (number > 7999) {
					decompose.push({numeral: this.number, roman: 'Not supported'});
				}
				while (number > 0) {
					let equiv = equivalences[i], roman = equiv.roman, numeral = equiv.numeral;
					if (equiv.numeral <= number) {
						let multiple = parseInt(number / equiv.numeral);
						roman = Math.pow(10, multiple).toString().replace('1', '').replace(/0/g, roman);
						number = number - multiple * numeral;
						// explain = multiple == 1 ? null : `${multiple * numeral} = ${multiple} x ${numeral}`;
						decompose.push({numeral: multiple * numeral, roman: roman, explain: explain});
						result += roman;
					} else {
						let next_equiv = equivalences.filter(el => el.numeral < numeral / 2 && numeral - el.numeral <= number).shift();
						if (next_equiv != undefined) {
							roman = `${next_equiv.roman}${equiv.roman}`;
							numeral = numeral - next_equiv.numeral;
							explain = `${numeral} = ${equiv.numeral} - ${next_equiv.numeral}`;
							decompose.push({numeral: numeral, roman: roman, explain: explain});
							number = number - (equiv.numeral - next_equiv.numeral)
							result += roman;
						}
						log (equiv.numeral, "is greater than", number, "next_equivs:", equivalences.filter(el => el.numeral < numeral / 2 && numeral - el.numeral <= number), "next_equiv:", next_equiv, 'roman:', roman, 'numeral:', numeral)
					}
					i++;
				}
				return {decompose: decompose, result: result};
			}
		}
	},
	watched: {}
}